export enum LanguageLocale {
    EN = 'en',
    PL = 'pl',
}

export enum LanguageLocaleType {
    EN = 'en-GB',
    PL = 'pl-PL',
}
